import TicketTypes from "../models/ticket-type";
import { HttpUtils } from "./http-utils";
import Subjects from "../models/subjects";

export interface NewTicketRequest {
    ticketType: TicketTypes;
    count: number;
    name: string;
}

export interface FinishTicketRequest {
    count: number;
    name: string;
}

export class TicketService {

    httpUtils: HttpUtils;
    webApiUrl: string;

    constructor(subject: Subjects) {
        this.httpUtils = new HttpUtils();
        this.webApiUrl = `/darshana/api/tickets/${subject}`;
    }

    loadCurrent = async (successHandler: ((data: any) => any)) => {
        const options = {
            method: "GET",
        }
        const request = new Request(`${this.webApiUrl}/current`, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    };

    loadFull = async (ticketId: number, successHandler: ((data: any) => any)) => {
        const options = {
            method: "GET",
        }
        const request = new Request(`${this.webApiUrl}/${ticketId}`, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    };

    createTicket = async (params: NewTicketRequest, successHandler: ((data: any) => any), errorHandler: ((data: string) => any)) => {

        const options = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params)
        }

        fetch(this.webApiUrl, options).then((response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler));
    };

    reset = async (ticketId: number, successHandler: (() => any), errorHandler: ((data: string) => any)) => {

        const options = {
            method: "PUT"
        }

        fetch(`${this.webApiUrl}/${ticketId}/reset`, options)
            .then((response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler));
    };

    finish = async (ticketId: number, params: FinishTicketRequest, successHandler: (() => any), errorHandler: ((data: string) => any)) => {

        const options = {
            method: "PUT",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params)
        }

        fetch(`${this.webApiUrl}/${ticketId}/finish`, options)
            .then((response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler));
    };

    rollback = async (ticketId: number, successHandler: (() => any)) => {

        const options = {
            method: "PUT"
        }

        fetch(`${this.webApiUrl}/${ticketId}/rollback`, options)
            .then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    };

    addTaskInList = async (ticketId: number, id: number, successHandler: ((data: any) => any), errorHandler: ((data: string) => any)) => {

        const options = {
            method: "POST"
        }

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler);

        fetch(`${this.webApiUrl}/${ticketId}/tasks/${id}`, options).then(handler);
    };

    deleteTaskInList = async (ticketId: number, id: number, successHandler: ((data: any) => any), errorHandler: ((data: string) => any)) => {

        const options = {
            method: "DELETE"
        }

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler);

        return await fetch(`${this.webApiUrl}/${ticketId}/tasks/${id}`, options).then(handler);
    };

    makePdf = async (ticketId: number, successHandler: ((data: any) => any), errorHandler: ((data: string) => any)) => {

        const options = {
            method: "POST"
        }

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler);

        fetch(`${this.webApiUrl}/${ticketId}/pdf`, options).then(handler);
    };

    regeneratePdf = async (ticketId: number, successHandler: ((data: any) => any), errorHandler: ((data: string) => any)) => {

        const options = {
            method: "PATCH"
        }

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler, errorHandler);

        fetch(`${this.webApiUrl}/${ticketId}/pdf`, options).then(handler);
    };


    loadList = async (urlParams: URLSearchParams, successHandler: ((data: any) => any)) => {

        const options = {
            method: "GET",
        }

        const request = new Request(`${this.webApiUrl}?${urlParams}`, options);

        fetch(request).then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    };

    assignStudents(ticketId: number, selectedStudents: number[], successHandler: (_: any) => any) {

        const options = {
            method: "PUT",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ students: selectedStudents })
        }

        const handler = (response: Response) => this.httpUtils.handleResponse(response, successHandler);

        fetch(`${this.webApiUrl}/${ticketId}/assigned-students`, options).then(handler);
    }

    createClone(ticketId: number, successHandler: (data: any) => void) {
        
        const options = {
            method: "PUT"
        }

        fetch(`${this.webApiUrl}/${ticketId}/clone`, options)
            .then((response: Response) => this.httpUtils.handleResponse(response, successHandler));
    }
}